export default {
  notConnected: 'Es besteht keine Verbindung zu einer unterstützten Datenquelle.',
};
